
import ImageHeader from '@/components/core/ImageHeader';

export default {
  scrollToTop: true,
  components: {
    ImageHeader,
  },
  head() {
    return {
      title: "Affiliate Marketing Services in Goa - Goa App",
      meta: [{
        hid: 'description',
        name: 'description',
        content: 'We connect your brand to the best affiliates, liaise with them to sell your product and manage your network of affiliates on a daily basis to help you grow.'
      },
      {
        hid: 'keywords',
        name: 'keywords',
        content: 'affiliate marketing in goa, affiliate marketing service, affiliate marketing india, best affiliate marketing websites'
      },
      {
        hid: 'og:title',
        property: 'og:title',
        content: 'Affiliate Marketing Services in Goa - Goa App'
      },
      {
        hid: 'og:description',
        property: 'og:description',
        content: 'We connect your brand to the best affiliates, liaise with them to sell your product and manage your network of affiliates on a daily basis to help you grow.'
      },
      {
        hid: 'twitter:title',
        property: 'twitter:title',
        content: 'Affiliate Marketing Services in Goa - Goa App'
      },
      {
        hid: 'twitter:description',
        property: 'twitter:description',
        content: 'We connect your brand to the best affiliates, liaise with them to sell your product and manage your network of affiliates on a daily basis to help you grow.'
      },
      {
        hid: 'og:image:alt',
        property: 'og:image:alt',
        content: 'Affiliate Marketing Services in Goa - Goa App'
      },
      {
        hid: 'og:image',
        property: 'og:image',
        content: this.$config.siteUrl + '/img/service-imgs/affiliate-marketing.webp'
      },
      {
        hid: 'image',
        property: 'image',
        content: this.$config.siteUrl + '/img/service-imgs/affiliate-marketing.webp'
      },
      {
        hid: 'twitter-image',
        property: 'twitter:image',
        content: this.$config.siteUrl + '/img/service-imgs/affiliate-marketing.webp'
      },

      ],
    }
  },
  scrollToTop: true,
  data() {
    return {
      title: 'Affiliate Marketing Services in Goa - Goa App',
      description: 'We connect your brand to the best affiliates, liaise with them to sell your product and manage your network of affiliates on a daily basis to help you grow.',
      eventCategoryModal: false,
      schemaData: [],

      interLinks: {
        "title": "Explore More Services on Goa App",
        "links": [
          {
            "sub_title": "Top Services",
            "interLinks": [
              {
                "name": "Digital Marketing Services in Goa",
                "url": "/digital-marketing"
              },
              {
                "name": "Website Development in Goa",
                "url": "/website-development"
              },
              {
                "name": "Search Engine Optimization in Goa",
                "url": "/search-engine-optimization"              
		},
              {
                "name": "Advertising in Goa",
                "url": "/Advertising"
              },
              {
                "name": "Graphic Designing in Goa",
                "url": "/graphic-design"
              },
              {
                "name": "Social Media Marketing in Goa",
                "url": "/social-media-marketing"
              },
              {
                "name": "Content Marketing in Goa",
                "url": "/content-marketing"
              }

            ]
          },
        ]
      }
    };
  },

 jsonld() {
  return {
    '@context': 'https://schema.org',
    '@graph': [
      {
        '@type': 'Service',
        '@id': 'https://goa.app/affiliate-marketing/#Service',
        'name': 'Affiliate Marketing',
        'serviceType': 'Digital Marketing',
        'additionalType': 'serviceOutput',
        'providerMobility': 'provider',
        'provider': {
          '@type': 'Corporation',
          'name': 'Goa App',
          'address': {
            '@type': 'PostalAddress',
            'addressLocality': 'Goa',
            'postalCode': '403505'
          },
          'telephone': '+91 9049248689'
        },
        'priceRange': '',
        "image": "https://goa.app/img/service-imgs/affiliate-marketing.webp",
        'description': 'We connect your brand to the best affiliates, liaise with them to sell your product, and manage your network of affiliates on a daily basis to help you generate leads and profit.',
         "datePublished": "2024-06-14T00:00:00",
          "dateModified":  "2024-06-14T00:00:00",
        'areaServed': {
          '@type': 'City',
          'name': 'Goa'
        },
        'hasOfferCatalog': {
          '@type': 'OfferCatalog',
          'name': 'Affiliate Marketing',
          'itemListElement': [
            { '@type': 'Offer', 'name': 'Affiliate Relationships' },
            { '@type': 'Offer', 'name': 'Brand Management' },
            { '@type': 'Offer', 'name': 'Content Management' },
            { '@type': 'Offer', 'name': 'Campaign Management' },
            { '@type': 'Offer', 'name': 'Technical Management' },
            { '@type': 'Offer', 'name': 'Data and Analytics' }
          ]
        }
      },
      {
        '@type': 'FAQPage',
        'mainEntity': [
          {
            '@type': 'Question',
            'name': 'What is affiliate marketing and why is it important?',
            'acceptedAnswer': {
              '@type': 'Answer',
              'text': 'Affiliate marketing is a service where an advertiser offers a reward to a publisher when they generate traffic, leads, or sales on behalf of the advertiser. An affiliate marketing agency in India, like Goa App, will help increase the sale of products as well as boost brand visibility by exposing your product or service to a new audience.'
            }
          },
          {
            '@type': 'Question',
            'name': 'What are the benefits of affiliate marketing?',
            'acceptedAnswer': {
              '@type': 'Answer',
              'text': 'Affiliate marketing works on a pay-per-action model, meaning you only pay for results. You can choose to pay per lead, sale, click, or action. As your digital marketing agency in Goa and Mumbai, Goa App will manage your affiliate marketing to benefit both you and your affiliate partners. This low-risk, cost-effective strategy offers clear tracking, allowing you to analyze effectiveness easily.'
            }
          },
          {
            '@type': 'Question',
            'name': 'What do your affiliate marketing fees include?',
            'acceptedAnswer': {
              '@type': 'Answer',
              'text': 'Similar to Pay Per Click Marketing, where you pay Google/Facebook for each click plus our management fee, the same applies to our ASO Services. Commissions need to be paid to publishers, and our management fee covers the collaboration with potentially hundreds of publishers each month.'
            }
          },
          {
            '@type': 'Question',
            'name': 'How will affiliate marketing fit into my digital strategy?',
            'acceptedAnswer': {
              '@type': 'Answer',
              'text': 'Affiliate marketing is an online strategy where businesses reward affiliates, or publishers, for sending visitors to their website, often resulting in sales, inquiries, and leads. A brand pays an affiliate when traffic converts into a sale, making it a cost-effective way to sell products/services and gain brand exposure.'
            }
          },
          {
            '@type': 'Question',
            'name': 'Do I need to pay commissions as soon as I get a sale?',
            'acceptedAnswer': {
              '@type': 'Answer',
              'text': 'No, most affiliate platforms work on a predefined payment schedule, usually 45 days after the sale, to protect the brand from order cancellations or spam orders. Get in touch with Goa App to learn more about how it works.'
            }
          },
          {
            '@type': 'Question',
            'name': 'Can you automate Affiliate Marketing?',
            'acceptedAnswer': {
              '@type': 'Answer',
              'text': 'Yes, to a certain extent, some aspects of affiliate marketing can be automated. However, Goa App still monitors metrics and manually reviews automated reports to identify where a brand needs more focus, what\'s working, and what\'s not.'
            }
          }
        ]
      }
    ]
  };
},

  mounted() {
    document.body.classList.add('modalOverflow');

    this.getHomeActitvitesData();
    this.getActitvitesData();
    this.getActitvitesCategoriesData();

    if (localStorage.getItem('recentlyViewed')) {
      this.recentlyViewed = JSON.parse(localStorage.getItem('recentlyViewed'))
    }

    if (localStorage.getItem('activitiesFilter')) {
      localStorage.removeItem('activitiesFilter');
    }
    this.$parent.$emit("sentInterLinks", this.interLinks);
  },

  destroyed() {
    document.body.classList.remove('modalOverflow')
    if (document.getElementById('filterClose'))
      document.getElementById('filterClose').click();
  },

  methods: {
    async getHomeActitvitesData() {
      this.allHomeActivitiesData = await fetch(this.$config.fetchUrl +
        '/api/posts/app/getActivitiesForActivityPageWithSlug').then(res => res
          .text());
      this.allHomeActivitiesData = this.getCryptKey(this.allHomeActivitiesData);
      this.homeactLoading = false;
      this.$nextTick(() => {
        if (this.allHomeActivitiesData) {
          var schemaResult = Object.keys(this.allHomeActivitiesData).map((key) => [this.allHomeActivitiesData[
            key].data]);
          schemaResult = schemaResult.flat(2);
          this.schemaData = [...new Map(schemaResult.map(v => [v.post._id, v])).values()]
        }
      })
      //this.changeThingsToDo(0)
    },

    async getActitvitesData() {
      this.allActivitiesData = await fetch(this.$config.fetchUrl + '/api/coupons/app/featuredCoupons').then(res =>
        res
          .text());
      this.allActivitiesData = this.getCryptKey(this.allActivitiesData);
      this.actLoading = false;
      // this.$nextTick(() => {
      //   if (this.allHomeActivitiesData) {
      //     this.schemaData = [...this.allHomeActivitiesData.featuredActivities, ...this.allHomeActivitiesData.photography, ...this.allHomeActivitiesData.hiddenGems];
      //     this.schemaData = [...new Map(this.schemaData.map(v => [v.post._id, v])).values()]
      //   }
      // })
    },

    async getActitvitesCategoriesData() {
      this.featuredCatsLoading = true;
      this.featuredCats = await fetch(this.$config.fetchUrl + '/api/posts/app/getCategoriesForActivityPageWithSlug').then(res =>
        res
          .text());
      this.featuredCats = this.getCryptKey(this.featuredCats);
      this.featuredCatsLoading = false;
    },

    changeThingsToDo(id) {
      switch (id) {
        case 0:
          this.thingsToDo = this.allHomeActivitiesData.featuredActivities;
          break;
        case 1:
          this.thingsToDo = this.allHomeActivitiesData.photography;
          break;
        case 2:
          this.thingsToDo = this.allHomeActivitiesData.hiddenGems;
          break;
        case 3:
          this.thingsToDo = this.allHomeActivitiesData.specialMoments;
          break;
        case 4:
          this.thingsToDo = this.allHomeActivitiesData.monsoonActivities;
          break;
        default:
          this.thingsToDo = this.allHomeActivitiesData.featuredActivities;
      }
    },

    getSpace(key) {
      return key.replace(/([A-Z])/g, " $1")
    },

    activitiesImage(image) {
      if (image.length > 0) {
        return image[0];
      } else {
        return '';
      }
    },

    // To add a fallback placeholder image if not rendereds from API
    setFallbackImageUrl(event) {
      event.target.src = require(`@/assets/img/placeholders/places.svg`)
    },

    activityVenue(seller) {
      if (seller && seller.length > 0 && seller[0].venue) {
        return seller[0].venue.name
      }
      return ""
    },

    activityDuration(seller) {
      if (seller && seller.length > 0 && seller[0].durationInHours) {
        return seller[0].durationInHours
      }
      return ""
    },

    activityPrice(seller) {
      if (seller && seller.length > 0 && seller[0].tickets && seller[0].tickets.length > 0 && seller[0].tickets[0]
        .prices && seller[0].tickets[0].prices.length > 0 && seller[0].tickets[0].prices[0].strikePrice) {
        return seller[0].tickets[0].prices[0].strikePrice
      }
      return 0
    },

    activityDiscountPrice(seller) {
      if (seller && seller.length > 0 && seller[0].tickets && seller[0].tickets.length > 0 && seller[0].tickets[0]
        .prices && seller[0].tickets[0].prices.length > 0 && seller[0].tickets[0].prices[0].price) {
        return seller[0].tickets[0].prices[0].price
      }
      return 0
    },

    checkIsOffer(seller) {
      let strikePrice = this.activityPrice(seller);
      let price = this.activityDiscountPrice(seller);
      if (strikePrice > price) {
        return true
      }
      return false
    },

    offerPercentage(seller) {
      if (this.checkIsOffer(seller)) {
        let strikePrice = this.activityPrice(seller);
        let price = this.activityDiscountPrice(seller);
        let offerPercentage = strikePrice - price;
        if (offerPercentage > 0) {
          return ((100 * (strikePrice - price) / strikePrice) > 0 && (100 * (strikePrice - price) /
            strikePrice) < 100) ? parseFloat((100 * (strikePrice - price) / strikePrice).toFixed(0)) : 0
        } else return 0
      }
      return 0
    },

    categoryBtnClicked(item) {
      if (item) {
        this.$router.push({
          path: item
        })
      }
    },

  }
}
